"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyBanner = void 0;
const react_1 = __importStar(require("react"));
const closeButton_svg_1 = __importDefault(require("../../../../assets/icons/closeButton.svg"));
const airbeam_mini_hero_webp_1 = __importDefault(require("../../../../assets/images/airbeam-mini-hero.webp"));
const S = __importStar(require("./SurveyBanner.style"));
const SURVEY_URL = "https://tally.so/r/XxB9DP";
const SURVEY_END_DATE = new Date("2026-05-07T23:59:59Z");
const DISMISSED_KEY = "aircasting_survey_dismissed_date";
const TAKEN_KEY = "aircasting_survey_taken";
const todayKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const safeGet = (k) => {
    try {
        return localStorage.getItem(k);
    }
    catch (_a) {
        return null;
    }
};
const safeSet = (k, v) => {
    try {
        localStorage.setItem(k, v);
    }
    catch (_a) {
        /* storage disabled / quota — ignore */
    }
};
const shouldShow = () => {
    if (Date.now() > SURVEY_END_DATE.getTime())
        return false;
    if (safeGet(TAKEN_KEY) !== null)
        return false;
    if (safeGet(DISMISSED_KEY) === todayKey())
        return false;
    return true;
};
const SurveyBanner = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(shouldShow);
    (0, react_1.useEffect)(() => {
        if (!isOpen)
            return;
        const reactApp = document.getElementById("react-app");
        reactApp === null || reactApp === void 0 ? void 0 : reactApp.setAttribute("inert", "");
        const firstFocusable = document.querySelector("#popup-root button, #popup-root a");
        firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
        return () => reactApp === null || reactApp === void 0 ? void 0 : reactApp.removeAttribute("inert");
    }, [isOpen]);
    if (!isOpen)
        return null;
    const dismiss = () => {
        safeSet(DISMISSED_KEY, todayKey());
        setIsOpen(false);
    };
    const takeSurvey = () => {
        safeSet(TAKEN_KEY, "1");
        setIsOpen(false);
    };
    return (react_1.default.createElement(S.SurveyPopup, { open: isOpen, modal: true, nested: true, closeOnDocumentClick: false, closeOnEscape: false, overlayStyle: { zIndex: 1100 } },
        react_1.default.createElement(S.Hero, null,
            react_1.default.createElement("img", { src: airbeam_mini_hero_webp_1.default, alt: "AirBeam Mini", decoding: "async" }),
            react_1.default.createElement(S.CloseButton, { onClick: dismiss, "aria-label": "Close" },
                react_1.default.createElement("img", { src: closeButton_svg_1.default, alt: "" }))),
        react_1.default.createElement(S.Body, null,
            react_1.default.createElement(S.Title, null, "Help shape AirCasting"),
            react_1.default.createElement(S.Description, null, "We're rebuilding the mobile app with you in mind. Take our short survey to share what's working \u2014 and what isn't."),
            react_1.default.createElement(S.Actions, null,
                react_1.default.createElement(S.PrimaryButton, { as: "a", href: SURVEY_URL, target: "_blank", rel: "noopener noreferrer", onClick: takeSurvey }, "Take the survey \u2192")))));
};
exports.SurveyBanner = SurveyBanner;
